<template>
  <div class="tinto-page">
    <Loading :isActive="loading" />

    <div class="tinto-aviso">
      <fa-icon icon="info-circle" class="mr-2" />
      Auditoria: <strong>um registro por alteração de crédito</strong>, na ordem em que aconteceram.
    </div>

    <!-- ===== FILTROS ===== -->
    <div class="tinto-filters">
      <div class="tinto-filtros__linha">
        <div class="tinto-filtros__busca">
          <input
            class="form-control"
            v-model="filtros.q"
            placeholder="Crédito, orçamento ou pedido ERP..."
            @keyup.enter="load()"
          />
        </div>
        <div class="tinto-filtros__acoes">
          <button class="button button-primary button--icone" @click="load()" title="Buscar">
            <fa-icon icon="search" />
          </button>
          <button
            class="button button-primary button--icone"
            :disabled="exportando"
            :title="exportando ? 'Gerando a planilha...' : 'Baixar Excel do conjunto filtrado'"
            @click="baixarExcel()"
          >
            <fa-icon :icon="exportando ? 'spinner' : 'download'" :spin="exportando" />
          </button>
          <button
            :class="['button', 'button--auto', filtrosAbertos ? 'button-primary' : '']"
            @click="filtrosAbertos = !filtrosAbertos"
          >
            <fa-icon icon="filter" /> Filtros
            <span v-if="totalFiltrosAtivos" class="tinto-filtros__contador">{{ totalFiltrosAtivos }}</span>
          </button>
        </div>
      </div>

      <div class="tinto-filtros__painel" v-if="filtrosAbertos">
        <CRow>
          <CCol md="3">
            <div class="tinto-campo">
              <label class="tinto-campo__label">Operação</label>
              <select class="form-control" v-model="filtros.operacoes" @change="load()">
                <option value="">Todas</option>
                <option v-for="(rotulo, operacao) in operacoes" :key="operacao" :value="operacao">
                  {{ rotulo }}
                </option>
              </select>
            </div>
          </CCol>
          <CCol md="3">
            <div class="tinto-campo">
              <label class="tinto-campo__label">Resultado</label>
              <select class="form-control" v-model="filtros.sucesso" @change="load()">
                <option value="">Todos</option>
                <option value="1">Sucesso</option>
                <option value="0">Falha</option>
              </select>
            </div>
          </CCol>
          <CCol md="2">
            <div class="tinto-campo">
              <label class="tinto-campo__label">Cliente</label>
              <input class="form-control" v-model="filtros.cliente_id" @keyup.enter="load()" />
            </div>
          </CCol>
          <CCol md="2">
            <div class="tinto-campo">
              <label class="tinto-campo__label">De</label>
              <input class="form-control" type="date" v-model="filtros.dtIni" @change="load()" />
            </div>
          </CCol>
          <CCol md="2">
            <div class="tinto-campo">
              <label class="tinto-campo__label">Até</label>
              <input class="form-control" type="date" v-model="filtros.dtFim" @change="load()" />
            </div>
          </CCol>
        </CRow>
      </div>

      <div class="tinto-chips" v-if="chipsFiltros.length">
        <span class="tinto-chips__titulo">Filtrando por</span>
        <span class="tinto-filtro-chip" v-for="chip in chipsFiltros" :key="chip.chave">
          <strong>{{ chip.rotulo }}:</strong> {{ chip.valor }}
          <span class="tinto-filtro-chip__remover" @click="removerFiltro(chip.chave)" title="Remover filtro">&times;</span>
        </span>
        <button class="tinto-chips__limpar" @click="limparFiltros()">limpar tudo</button>
      </div>
    </div>

    <!-- ===== TABELA ===== -->
    <div class="tinto-table-wrap">
      <table class="tinto-table">
        <thead><tr>
          <th style="width:145px">Quando</th>
          <th style="width:210px">Operação</th>
          <th style="width:110px">Crédito</th>
          <th style="width:90px">Cliente</th>
          <th style="width:140px">Orçamento</th>
          <th style="width:110px">Pedido ERP</th>
          <th style="width:130px">Antes → Depois</th>
          <th style="width:100px">Resultado</th>
        </tr></thead>
        <tbody>
          <tr v-if="items.length === 0">
            <td colspan="8" class="tinto-table__empty">Nenhum movimento para os filtros</td>
          </tr>
          <tr v-for="movimento in items" :key="movimento.id">
            <td>{{ movimento.datahora_criacao | datetime }}</td>
            <td>
              <span :class="['tinto-badge', badgeOperacao(movimento.operacao)]">
                {{ operacoes[movimento.operacao] || movimento.operacao }}
              </span>
            </td>
            <td class="tinto-table__primary">{{ movimento.credito_id || '—' }}</td>
            <td>{{ movimento.cliente_id }}</td>
            <td>{{ movimento.orcamento_id || '—' }}</td>
            <td>{{ movimento.pedidoerp_id || '—' }}</td>
            <td>{{ faixaValores(movimento) }}</td>
            <td>
              <span :class="['tinto-badge', movimento.sucesso ? 'tinto-badge--success' : 'tinto-badge--error']">
                {{ movimento.sucesso ? 'Sucesso' : 'Falha' }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="tinto-pagination" v-if="paginator.last_page > 1">
      <pagination :data="paginator" :limit="5" @pagination-change-page="load" />
    </div>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import listagemMixin from "@/mixins/listagemMixin";
import { downloadBlob } from "@/helpers/downloadBlob";
import { OPERACOES } from "./helpers";

export default {
  name: "creditos-clientes-movimentos",
  components: { Loading },
  mixins: [listagemMixin],

  props: {
    // Busca aplicada ao abrir a aba a partir de outra visão (um crédito do
    // Extrato, uma operação das Movimentações). O seq muda a cada clique,
    // para reaplicar mesmo quando a busca é a mesma.
    presetBusca: { type: String, default: "" },
    presetSeq: { type: Number, default: 0 },
  },

  data() {
    return {
      listagemEndpoint: "/admin/creditos-clientes/movimentos",
      sort: { by: "datahora_criacao", dir: "desc" },
      exportando: false,
      filtros: {
        q: this.presetBusca || "", operacoes: "", sucesso: "", cliente_id: "", dtIni: "", dtFim: "",
      },
      rotulosFiltros: {
        q: "Busca", operacoes: "Operação", sucesso: "Resultado",
        cliente_id: "Cliente", dtIni: "De", dtFim: "Até",
      },
      operacoes: OPERACOES,
    };
  },

  watch: {
    presetSeq() {
      this.filtros.q = this.presetBusca || "";
      this.load();
    },
  },

  methods: {
    appendFiltros(params) {
      Object.entries(this.filtros).forEach(([chave, valor]) => {
        if (valor !== "" && valor !== null) params.append(chave, valor);
      });
    },

    descreverFiltro(chave, valor) {
      if (chave === "operacoes") return this.operacoes[valor] || valor;
      if (chave === "sucesso") return valor === "1" ? "Sucesso" : "Falha";
      return valor;
    },

    async baixarExcel() {
      this.exportando = true;

      try {
        const params = new URLSearchParams();
        this.appendFiltros(params);

        await downloadBlob(`/admin/creditos-clientes/movimentos/exportar?${params}`, "movimentos-credito.xlsx");
      } catch (error) {
        this.$swal({
          title: "Erro ao exportar",
          text: error.message,
          icon: "error",
        });
      } finally {
        this.exportando = false;
      }
    },

    badgeOperacao(operacao) {
      if (operacao === "CONFIRMACAO") return "tinto-badge--success";
      if (operacao === "LIBERACAO" || operacao === "BAIXA_DIFERENCA") return "tinto-badge--warn";
      if (operacao === "GERACAO_DIFERENCA") return "tinto-badge--teal";
      return "tinto-badge--muted";
    },

    faixaValores(movimento) {
      const antes = movimento.valor_antes;
      const depois = movimento.valor_depois;

      if (antes === null && depois === null) return "—";

      const formata = (v) => (v === null ? "—" : Number(v).toLocaleString("pt-BR", { minimumFractionDigits: 2 }));

      if (antes !== null && depois !== null && Number(antes) !== Number(depois)) {
        return `${formata(antes)} → ${formata(depois)}`;
      }

      return formata(depois !== null ? depois : antes);
    },
  },
};
</script>

